<template>
    <div class="notes_view_for_wrp">
  <div class="notes_view_inner_wrp">
      <div class="notes_view_inner_bg">
        <div class="notes_view_header_wrp">
          <div class="row align-items-center">
            <div class="col">
              <ul class="notes_view_header_list">
                <li><i class="fa fa-compress" aria-hidden="true" @click="backToNormalViewMethod()"></i></li>
              </ul>
            </div>
            <div class="col">
              <ul class="notes_view_header_list justify-content-end">
                <li v-if="fullViewModeEditable"><i class="fa fa-pencil" aria-hidden="true" @click="fullViewModeEditableMethod()"></i></li>
                <li v-else><i class="fa fa-check" aria-hidden="true" @click="fullViewModeEditableMethod()"></i></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="notes_view_body_wrp note_for_textarea_styling">
          <template v-if="fullViewModeEditable">
            <h2 class="notes_view_title">{{notesViewData.title}}</h2>
            <div class="notes_view_content readonly_html_note_text" v-html="notesViewData.data"></div>
          </template>
          <template v-else>
            <template v-if="notesViewData.under_editing && notesViewData.edited_by.id != this.selfUserId">
              <span class="currently_updating_txt">{{notesViewData.edited_by.first_name}} {{notesViewData.edited_by.last_name}} is currently updating the document. Please wait for your teammate to complete their notes, after which you can update and save your changes.</span>
              <input type="text" class="title_insert_notes_textarea" v-model="notesViewData.title" readonly>
              <div v-html="notesViewData.data" class="readonly_html_note_text"></div>
            </template>
            <template v-else>
              <input type="text" class="notes_view_title" v-model="notesViewData.title" @keyup="updatedSharedNotesNotificationMethod(notesViewData.id)" @change="updatedInsertedNotesDataMethod(notesViewData.data,notesViewData.title,notesViewData.id)">
              <!-- <textarea v-model="notesViewData.data" class="notes_view_content" @keyup="updatedSharedNotesNotificationMethod(notesViewData.id)" @change="updatedInsertedNotesDataMethod(notesViewData.data,notesViewData.title,notesViewData.id)"></textarea> -->
              <vue-editor v-model="notesViewData.data" :editorToolbar="customToolbar" :value="editorData" placeholder="Description..." :config="editorOptions" @blur="updatedInsertedNotesDataMethod(notesViewData.data,notesViewData.title,notesViewData.id)" @focus="updatedSharedNotesNotificationMethod(notesViewData.id)"></vue-editor>
            </template>
          </template>
        </div>
      </div>
  </div>
</div>
</template>

<script>
/*eslint-disable */
var $ = window.jQuery = require('jquery');
import {
  bus
} from '@/main';
import { VueEditor } from "vue2-editor";
export default {
  name: 'notes-view-section',
  components: {
    VueEditor
  },
  props: ['notesViewDATA'],
  data () {
    return {
      fullViewModeEditable:true,
      notesViewData:{},
      keyUpEvent:false,
      selfUserId:'',
      editorOptions: {
        placeholder: 'Description...'
      },
      customToolbar: [
        ["bold", "italic", "underline", { color: [] }, { background: [] }]
      ],
      editorData: '',
    }
  },
  computed: {

  },
  mounted () {
    this.notesViewData = this.notesViewDATA
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
  },
  methods: {
    backToNormalViewMethod(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('notesViewPopupBus', false);
    },
    fullViewModeEditableMethod(){
      if(this.fullViewModeEditable == true){
        this.fullViewModeEditable = false
      }else{
        this.fullViewModeEditable = true
      }
    },
    updatedInsertedNotesDataMethod(updateData,updateTitle,updateId){
      let data = {
        data:updateData,
        title:updateTitle
      }
      this.$store.dispatch('updateNewNotesDetailsFun',{data:{data:data,id:updateId}}).then((res)=>{
        this.updatedSharedNotesNotificationFalseMethod(updateId)
      }).catch((err)=>{})
    },
    updatedSharedNotesNotificationMethod(updateId){
      if(this.keyUpEvent) return;
      let data = {
        under_editing:true,
        edited_by:this.selfUserId
      }
      this.$store.dispatch('updateNewNotesDetailsFun',{data:{data:data,id:updateId}}).then((res)=>{
        this.keyUpEvent = true
      }).catch((err)=>{})
    },
    updatedSharedNotesNotificationFalseMethod(updateId){
      let data = {
        under_editing:false,
        edited_by:this.selfUserId
      }
      this.$store.dispatch('updateNewNotesDetailsFun',{data:{data:data,id:updateId}}).then((res)=>{
        this.keyUpEvent = false
      }).catch((err)=>{})
    },
    getAgainAllNotesDetailsForUpdateMethod(){
      this.$store.dispatch('getAllNotesListFun').then((res)=>{
      }).catch((err)=>{})
    },
    sharedNotesListMethod(){
      this.$store.dispatch('getAllSharedNotesListFun').then((res)=>{
      }).catch((err)=>{})
    },
  }
}
</script>

<style lang="scss" scoped>
.notes_view_for_wrp {position: fixed;left: 0;top: 0;right: 0;background: rgba(0, 0, 0, 0.92);bottom: 0;z-index: 1100;}.notes_view_for_wrp .notes_view_inner_bg {background-repeat: no-repeat;background-size: cover;background-image: url("../../../../../assets/images/paper_texture.jpg");max-width: 700px;margin: 15px auto 0;border-radius: 4px;height: calc(100dvh - 30px);}.notes_view_for_wrp .notes_view_header_wrp {background: rgba(0, 0, 0, 0.1);border-radius: 5px 5px 0px 0px;padding: 0px;}.notes_view_for_wrp .notes_view_header_wrp .notes_view_header_list {margin: 0;display: flex;align-items: center;}.notes_view_for_wrp .notes_view_header_wrp .notes_view_header_list li {margin-right: 5px;}.notes_view_for_wrp .notes_view_header_wrp .notes_view_header_list li:last-child {margin-right: 0px;}.notes_view_for_wrp .notes_view_header_wrp .notes_view_header_list li .fa {font-size: 24px;color: #000000;cursor: pointer;padding: 10px;}.notes_view_for_wrp .notes_view_header_wrp .notes_view_header_list li .fa:hover {background: rgba(0, 0, 0, 0.1);}.notes_view_for_wrp .notes_view_body_wrp {padding: 15px;}.notes_view_for_wrp .notes_view_body_wrp .notes_view_title {width: 100%;border: none;resize: none;background: none;outline: none;font-size: 32px;font-weight: 900;font-family: 'simplicitymedium';letter-spacing: 1px;line-height: 1.1;border-bottom: 1px solid rgba(0, 0, 0, 0.05);padding: 0px 0 10px;color: #660000;margin-bottom: 0px;}.notes_view_for_wrp .notes_view_body_wrp .notes_view_content {margin: 0;font-size: 22px;color: #000000;height: calc(100dvh - 150px);overflow-y: auto;line-height:1.45;padding: 10px 0px 0px;white-space: break-spaces;border: none !important;box-shadow: none !important;outline: none !important;background: none;width: 100%;resize: none;}.notes_view_for_wrp .notes_view_body_wrp .notes_view_content::-moz-placeholder {color: rgba(0, 0, 0, 0.5);}.notes_view_for_wrp .notes_view_body_wrp .notes_view_content::-webkit-input-placeholder {color: rgba(0, 0, 0, 0.5);}.notes_view_for_wrp .notes_view_body_wrp .notes_view_content::-webkit-scrollbar {width: 5px;background: none;}.notes_view_for_wrp .notes_view_body_wrp .notes_view_content::-webkit-scrollbar-thumb {border-radius: 10px;background-color: rgba(0, 0, 0, 0.18);}.notes_view_for_wrp .currently_updating_txt {margin-bottom: 10px;color: #7e009a;font-size: 20px;line-height: 1;display: block;font-family: 'MyriadProRegular','Lato',sans-serif;}
</style>